import React from 'react';
import DemoHero from '../components/demo/DemoHero';
import DemoInviteMessage from '../components/demo/DemoInviteMessage';
import DemoVenue from '../components/demo/DemoVenue';
import DemoTentative from '../components/demo/DemoTentative';
import DemoCountdown from '../components/demo/DemoCountdown';
import DemoBottomBar from '../components/demo/DemoBottomBar';
import { Helmet } from 'react-helmet';
import BackButton from '../components/BackButton';
import NavBar from '../components/NavBar';
import themes from '../components/Themes';

function Demo() {

  const theme = localStorage.getItem('theme');
  const Bg = themes[theme];

  return (
    <div className={`${Bg.textColor} ${Bg.themeColor}`}>
      <Helmet>
        <title>Preview | {process.env.REACT_APP_SITE_NAME}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <BackButton />
      {/* <NavBar /> */}
      <DemoHero />
      {/* <DemoInviteMessage /> */}
      <DemoVenue />
      <DemoTentative />
      <DemoCountdown />
      <DemoBottomBar />
    </div>
  );
}

export default Demo;
